import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { GroupDTO } from './useGetGroups';

export const useGetGroup = (groupId: string, options: { enabled?: boolean } = {}) => {
	return useQuery({
		queryKey: ['group', groupId],
		enabled: options.enabled ?? !!groupId,
		queryFn: async () => {
			const { data } = await api.get<GroupDTO>(`/management/group/findOne/${groupId}`);
			return data;
		},
	});
};
